define.alias("shared/utils/analytics/generate-cache-key", "preview-grid/utils/analytics/generate-cach-key");